import styled from "styled-components";
import CompactTable, {
  leftColumnPrimaryStyle,
  leftColumnSecondaryStyle,
  rightColumnPrimaryStyle,
  rightColumnSecondaryStyle,
} from "../../components/organisms/CompactTable";
import { offsetReportOutputParams as params } from "../../lib/gpConfig";
import { formatNumberToFixed } from "../../utils/otherUtils";
import { UnitSpan } from "../../components/atoms/Text";

const Container = styled.div`
  padding-inline: 12px;
  margin-bottom: 36px;
`;

const leftPrimaryStyle = { width: "75%", ...leftColumnPrimaryStyle };
const rightPrimaryStyle = { width: "25%", ...rightColumnPrimaryStyle };
const leftSecondaryStyle = { width: "75%", ...leftColumnSecondaryStyle };
const rightSecondaryStyle = { width: "25%", ...rightColumnSecondaryStyle };

const primaryRowStyles = [leftPrimaryStyle, rightPrimaryStyle];
const secondaryRowStyles = [leftSecondaryStyle, rightSecondaryStyle];

interface IProps {
  offsetResults: any;
}

function OffsetSummary({ offsetResults }: IProps) {
  const getTotalAreaRow = (totalAreaLabel: any, totalAreaValue: string) => {
    return [<div>{totalAreaLabel}</div>, <div>{totalAreaValue}</div>];
  };

  const getRowData = (param: string) => {
    const { key, label, unit } = (params as any)[param];
    const fullLabel = (
      <span key={key}>
        {label}
        {unit && <UnitSpan>({unit})</UnitSpan>}
      </span>
    );
    let value = offsetResults[key].value;
    if (unit) {
      value = formatNumberToFixed(value, 4);
    }
    if (param === "totalOffsetArea") {
      return getTotalAreaRow(fullLabel, value);
    }
    return [fullLabel, value];
  };

  const rows: any = [
    {
      rowData: getRowData("totalOffsetArea"),
      rowStyles: primaryRowStyles,
    },
    {
      rowData: getRowData("patchesArea"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("scatteredTreesArea"),
      rowStyles: secondaryRowStyles,
    },
    {
      rowData: getRowData("revegetationAreasArea"),
      rowStyles: secondaryRowStyles,
    },
  ];

  return (
    <Container>
      <CompactTable
        rows={rows}
        getRowKey={(row: any) => row[0].key}
      ></CompactTable>
    </Container>
  );
}

export default OffsetSummary;
